import { combineReducers } from 'redux';
import LoginRedux from '../LoginRedux';
import productRedux from '../ProductRedux';
import categoryRedux from '../CategoryRedux';
import homeSlideRedux from '../HomeSlideRedux';
import newseventsRedux from '../NewsEventsRedux';
import sellerRedux from '../SellerRedux';
import buyerRedux from '../BuyerRedux';
import userRedux from '../UserRedux.js';
import cartRedux from '../CartRedux.js';
import orderRedux from '../OrderRedux.js';
import ratingRedux from '../RatingRedux.js';
import partnersRedux from '../partnersRedux.js';

const rootReducer = combineReducers({
  LoginRedux: LoginRedux,
  productRedux: productRedux,
  categoryRedux: categoryRedux,
  homeSlideRedux: homeSlideRedux,
  newseventsRedux: newseventsRedux,
  sellerRedux: sellerRedux,
  buyerRedux: buyerRedux,
  userRedux: userRedux,
  cartRedux: cartRedux,
  orderRedux: orderRedux,
  ratingRedux:ratingRedux,
  partnersRedux: partnersRedux,
});

export default rootReducer;
